export default __webpack_public_path__ + "static/media/OPD_CARD_COVER_V1.92b1fd15.png";